import { render, staticRenderFns } from "./abstrRegistListPage.vue?vue&type=template&id=293edd3a&scoped=true&"
import script from "./abstrRegistListPage.vue?vue&type=script&lang=js&"
export * from "./abstrRegistListPage.vue?vue&type=script&lang=js&"
import style0 from "./abstrRegistListPage.vue?vue&type=style&index=0&id=293edd3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293edd3a",
  null
  
)

export default component.exports